import {useCallback, useMemo, useState} from 'react'

import {posthogTrack} from 'src/utils'

interface ITemplate {
	id: number
	isActive: boolean
	theme?: TPdfDocumentsThemes
}

export default function useChooseTemplate<T extends ITemplate = ITemplate>(documentTemplates: T[]) {
	const [templates, setTemplates] = useState<T[]>(documentTemplates)

	const activeTemplate = useMemo(() => {
		return templates.find((item) => item.isActive) || templates[0]
	}, [templates])

	const handleActiveTemplate = useCallback(
		(id: number) => {
			const updatedTemplates = templates.map((item) => {
				return {
					...item,
					isActive: item.id === id,
				}
			})

			setTemplates(updatedTemplates)
			posthogTrack('Template changed')
		},
		[templates],
	)

	const handleTemplateTheme = useCallback(
		(id: number, theme: T['theme']) => {
			const updatedTemplates = templates.map((item) => {
				if (item.id === id) {
					return {
						...item,
						theme,
					}
				}
				return item
			})

			setTemplates(updatedTemplates)
			posthogTrack("Template's theme changed")
		},
		[templates],
	)

	return {
		templates,
		activeTemplate,
		handleActiveTemplate,
		handleTemplateTheme,
	}
}
